import { BRAND, type Brand } from '../../brand';

/**
 * Brand name for headings: the wordmark when the brand ships one (keeping the
 * name as screen-reader text), otherwise the plain name.
 */
export function BrandMark({ brand = BRAND }: { brand?: Brand }) {
	if (!brand.logo) return <>{brand.name}</>;
	return (
		<>
			<span className="sr-only">{brand.name}</span>
			<svg
				className="brandmark"
				viewBox={brand.logo.viewBox}
				fill={brand.logo.fill}
				aria-hidden="true"
				focusable="false"
			>
				{brand.logo.paths.map((d) => (
					<path key={d.slice(0, 24)} d={d} />
				))}
			</svg>
		</>
	);
}
